import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { StarBattlePresence } from "./Player";
import { registerStarBattleTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  StarBattleDefinition,
  StarBattleProgress,
  StarBattleSolution,
  StarBattleSubmission,
} from "./types";

registerStarBattleTranslations(i18n);

export const starBattleModule: PuzzleTypeModule<
  StarBattleDefinition,
  StarBattleSubmission,
  StarBattleProgress,
  StarBattleSolution,
  StarBattlePresence
> = {
  key: "star_battle",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
